import {useSlideshowContext} from '../'

const classNameMap = {
  active: 'size-spacing-8 scale-100 bg-interactive-glyph-inversed-default transition-all',
  near: 'size-spacing-8 scale-75 bg-interactive-glyph-inversed-default/50 transition-all',
  far: 'size-spacing-8 scale-50 bg-interactive-glyph-inversed-default/50 transition-all',
}

const translateDotWidth = 24 // 8px Dot width + 16px gap

const getClassNameByDistance = (distance: number): string => {
  if (distance === 0) return classNameMap.active
  if (distance === 1) return classNameMap.near
  return classNameMap.far
}

const Dot = ({index}: {index: number}) => {
  const {currentIndex} = useSlideshowContext()
  const distanceToActive = Math.abs(currentIndex - index)
  const className = getClassNameByDistance(distanceToActive)

  return (
    <div className={className} />
  )
}

export const SlideshowDotIndicators = () => {
  const {items, currentIndex} = useSlideshowContext()
  // Active dot is not in the center of the container when one of the first or last two items are active
  // That's why we use "currentIndex - 2" and "items.length - 5"
  let translate = -1 * (currentIndex - 2) * translateDotWidth
  translate = Math.min(0, translate)
  translate = Math.max(translate, -1 * (items.length - 5) * translateDotWidth)

  return (
    /* 104px is 5 Dots + gap = 5*8px + 4*16px = 104px */
    <div className={'relative h-spacing-44 w-[104px] overflow-hidden md:hidden'}>
      <div
        className={'absolute inset-y-0 flex items-center space-x-spacing-16 transition-all'}
        style={{transform: `translateX(${translate}px)`}}
      >
        {items.map((_, index) => (
          <Dot
            index={index}
            key={index}
          />
        ))}
      </div>
    </div>
  )
}
